export function formatFinancialNumber(value, currency = 'USD') {
    if (value == null || value === '') {
        return "Not Provided";
    }
    // Validate currency code: must be a 3-letter string
    const validCurrency = typeof currency === 'string' && /^[A-Z]{3}$/i.test(currency) ? currency.toUpperCase() : 'USD';
    if (typeof value === 'number') {
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: validCurrency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value);
        } catch (e) {
            // Fallback in case of error
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value);
        }
    }
    return value;
}

